import React from "react";
import { BlogComponent } from "./blogComponent";
import { ArticleShimmer } from "./articleShimmer";
import Routes from "router/routes";
import { useNavigate } from "react-router-dom";

interface RecentBlogsProps {
  articles: any[];
  isLoading: boolean;
  recentBlogsSectionRef: React.RefObject<HTMLDivElement>;
  recentBlogsTitleRef: React.RefObject<HTMLParagraphElement>;
  blogsGridRef: React.RefObject<HTMLDivElement>;
  blogItemsRef: React.RefObject<(HTMLDivElement | null)[]>;
}

export const RecentBlogs: React.FC<RecentBlogsProps> = ({
  articles,
  isLoading,
  recentBlogsSectionRef,
  recentBlogsTitleRef,
  blogsGridRef,
  blogItemsRef,
}) => {
  const navigate = useNavigate();

  const handleBlogItemRef = (el: HTMLDivElement | null, index: number) => {
    if (blogItemsRef.current) {
      blogItemsRef.current[index] = el;
    }
  };

  return (
    <div className="bg-[#022928] lg:max-h-[3000px]">
      <div
        ref={recentBlogsSectionRef}
        className="mx-[16px] pt-[56px] lg:mx-[75px] lg:w-[613px] lg:pt-[120px]"
      >
        <p
          ref={recentBlogsTitleRef}
          className="font-inter text-[42px] font-medium capitalize leading-[100%] tracking-[-0.03em] text-white lg:font-dm-sans lg:text-[72px] lg:text-[#FFFEFD]"
        >
          Our recent blogs and resources
        </p>
      </div>
      <div
        ref={blogsGridRef}
        className="mx-[16px] mt-[64px] grid grid-cols-1 gap-[32px] lg:mx-[75px] lg:grid-cols-2 lg:gap-x-[64px] lg:gap-y-[80px]"
      >
        {isLoading ? (
          <>
            <ArticleShimmer />
            <ArticleShimmer />
            <ArticleShimmer />
            <ArticleShimmer />
          </>
        ) : articles.length ? (
          articles.slice(0, 6).map((blog, index) => (
            <div key={blog.id} ref={(el) => handleBlogItemRef(el, index)}>
              <BlogComponent
                blog={blog}
                onClick={() => {
                  navigate(Routes.BLOG_POST(blog.slug), {
                    state: blog,
                  });
                }}
              />
            </div>
          ))
        ) : (
          <div className="text-xl col-span-2 flex h-64 items-center justify-center text-white">
            No blogs available
          </div>
        )}
      </div>
    </div>
  );
};
